
export enum TipoFormularioEnum {
  FormularioCustomizado = 'FormularioCustomizado',
}
